import { errorMessage } from "../../utils/helpers";

export const CUSTOM_AUDIT_XML_ONLY_MESSAGE = "Invalid file type. Supported format is XML.";
const CUSTOM_AUDIT_UPLOAD_FALLBACK_MESSAGE = "Template upload failed.";

export type CustomAuditTemplateFileType = "xml" | "csv";

export const resolveCustomAuditTemplateFileType = (file: File): CustomAuditTemplateFileType | null => {
  const extension = file.name.split(".").pop()?.toLowerCase();
  if (extension === "xml" || extension === "csv") {
    return extension;
  }

  const mimeType = file.type.toLowerCase();
  if (mimeType.includes("xml")) {
    return "xml";
  }

  if (mimeType.includes("csv") || mimeType.includes("vnd.ms-excel")) {
    return "csv";
  }

  return null;
};

export const extractCustomAuditUploadErrorMessage = (error: any): string => {
  const backendMessage = typeof error?.data?.message === "string" ? error.data.message.trim() : "";
  if (backendMessage.length > 0) {
    return backendMessage;
  }

  const textMessage = typeof error?.data === "string" ? error.data.trim() : "";
  if (textMessage.length > 0) {
    return textMessage;
  }

  const fallbackMessage = typeof error?.error === "string" ? error.error.trim() : "";
  if (fallbackMessage.length > 0) {
    return fallbackMessage;
  }

  const genericMessage = errorMessage(error);
  if (typeof genericMessage === "string") {
    const normalizedMessage = genericMessage.trim();
    if (normalizedMessage.length > 0 && !normalizedMessage.startsWith("{") && !normalizedMessage.startsWith("[")) {
      return normalizedMessage;
    }
  }

  return CUSTOM_AUDIT_UPLOAD_FALLBACK_MESSAGE;
};